import type { GlobalConfig } from 'ngx-toastr';

import { RcToastComponent } from './rc-toast.component';
import type { RcToastPayload } from './rc-toast.model';

export const RC_TOAST_CONFIG: Partial<GlobalConfig<RcToastPayload>> = {
  toastComponent: RcToastComponent,
  progressBar: false,
  closeButton: true,
  timeOut: 10000,
  extendedTimeOut: 3000,
  easeTime: 220,
  countDuplicates: true,
  preventDuplicates: true,
  resetTimeoutOnDuplicate: true,
  maxOpened: 6,
  autoDismiss: true,
  positionClass: 'toast-top-right',
};
